import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ApiService } from 'src/app/services/api/api.service';
import Utils from 'src/app/helpers/utils';
import {
  BreadcrumbService,
  BreadcrumbItem,
} from 'src/app/services/breadcrumb/breadcrumb.service';
import { DRAFTS_PAGE_URL, draftsTabUrl } from 'src/app/data/draft-tabs';

@Component({
  selector: 'app-dashboard-drafts-bonds-form',
  templateUrl: './dashboard-drafts-bonds-form.component.html',
  styleUrls: ['./dashboard-drafts-bonds-form.component.scss'],
})
export class DashboardDraftsBondsFormComponent implements OnInit {
  label: string = 'Adicionar conjunto de permissões';

  loading: boolean = true;

  form = this.formBuilder.group({
    model: [null, Validators.required],
    risk: [null, Validators.required],
  });

  searchForm = this.formBuilder.group({
    avaliableUsers: [null],
    selectedUsers: [null],
    avaliablePermissions: [null],
    selectedPermissions: [null],
  });

  user: NewLoginResponse | undefined;

  isEditing: boolean = false;
  alreadyLoadedOptions: boolean = false;
  createdBy: string = '';
  modelsOptions: SelectItem[] = [];
  users: SelectItem[] = [];
  permissions: SelectItem[] = [];

  //   loadingUsers: boolean = true;
  batchSize = 30;
  offset = 0;

  //   Users variables

  totalUsersSelectedOptions = 0;
  usersSelectedCheckedNumber = 0;
  totalUsersAvaliableOptions = 0;
  usersAvaliableCheckedNumber = 0;

  //   avaliableOrderAsc = true;
  //   selectedOrderAsc = true;

  usersSelectedPicked: SelectItem[] = [];
  usersAvaliablePicked: SelectItem[] = [];

  usersAvaliable: SelectItem[] = [];
  usersSelected: SelectItem[] = [];
  visibleUsersSelected: SelectItem[] = [];

  //   -------
  initialUsersData: any = [];
  initialPermissionsData: any = [];

  isMaster: boolean = false;
  isSimple: boolean = false;

  userfirstTimeRequest = true;
  permissionsFirstTimeRequest = true;

  //   Permissionns variables

  totalPermissionsSelectedOptions = 0;
  permissionsSelectedCheckedNumber = 0;
  totalPermissionsAvaliableOptions = 0;
  permissionsAvaliableCheckedNumber = 0;

  permissionsSelectedPicked: SelectItem[] = [];
  permissionsAvaliablePicked: SelectItem[] = [];

  permissionsAvaliable: SelectItem[] = [];
  permissionsSelected: SelectItem[] = [];
  visiblePermissionsSelected: SelectItem[] = [];

  sendingRequest: boolean = false;
  riskOptions: SelectItem[] = [
    { label: 'Com risco', value: 'with_risk' },
    { label: 'Sem risco', value: 'no_risk' },
  ];

  constructor(
    public route: Router,
    public formBuilder: FormBuilder,
    private authService: AuthService,
    private toast: ToastService,
    private api: ApiService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.authService.canViewPage(['de_can_add_bonds']);

    this.isEditing = !this.route.url.includes('new');

    this.setBreadcrumb();

    this.user = this.authService.getUser();
    this.getData();

    this.label = this.route.url.includes('new')
      ? 'Vincular template'
      : 'Atualizar vinculo';

    this.searchForm.controls.avaliableUsers.valueChanges.subscribe(
      async (value) => {
        this.usersAvaliablePicked = [];
        await this.getRoles();

        this.filterUsers();
        this.handleSetNumbers(true, true);
      }
    );

    this.searchForm.controls.selectedUsers.valueChanges.subscribe((value) => {
      this.usersSelectedPicked = [];

      this.visibleUsersSelected = this.usersSelected.filter((item) =>
        item.label.toLowerCase().includes(value.toLowerCase())
      );
      this.handleSetNumbers(true);
    });

    this.searchForm.controls.avaliablePermissions.valueChanges.subscribe(
      async (value) => {
        this.permissionsAvaliablePicked = [];
        await this.getPermissionGroups(value);

        this.filterPermissions();
        this.handleSetNumbers(false, true);
      }
    );

    this.searchForm.controls.selectedPermissions.valueChanges.subscribe(
      (value) => {
        this.permissionsSelectedPicked = [];

        this.visiblePermissionsSelected = this.permissionsSelected.filter(
          (item) => item.label.toLowerCase().includes(value.toLowerCase())
        );
        this.handleSetNumbers();
      }
    );
  }

  filterUsers() {
    this.usersAvaliable = this.usersAvaliable.filter((item) => {
      return !this.usersSelected.some(
        (selected) => selected.value === item.value
      );
    });
  }

  filterPermissions() {
    this.permissionsAvaliable = this.permissionsAvaliable.filter((item) => {
      return !this.permissionsSelected.some(
        (selected) => selected.value === item.value
      );
    });
  }

  async getData() {
    await Promise.all([this.getPermissionGroups(), this.getRoles()]);

    if (this.isEditing) {
      await this.getGroupPermissionData();
    }

    this.loading = false;
  }

  async getRoles() {
    try {
      const res = await this.api.get({
        route: 'api/draft/',
        token: true,
        params: {
          no_pagination: true,
        },
      });

      const models = res.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));

      this.modelsOptions = models;
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Erro ao buscar modelos');
    }
  }

  async getPermissionGroups(params?: string) {
    try {
      const res = await this.api.get({
        route: 'api/registration/fund',
        token: true,
        params: {
          search: params,
        },
      });

      this.permissions = res.funds.map((item: any) => ({
        label: item.name,
        value: item.id,
      }));

      if (this.permissionsFirstTimeRequest) {
        this.initialPermissionsData.forEach((item: number) => {
          const finded = this.permissions.find(
            (permission) => permission.value === item
          );

          if (finded) this.permissionsSelected.push(finded);
        });
      }

      this.permissionsAvaliable = this.permissions;

      if (this.permissionsFirstTimeRequest) {
        this.permissionsSelected.forEach((permission) => {
          this.permissionsAvaliable = this.permissionsAvaliable.filter(
            (item) => item.value !== permission.value
          );
        });

        this.visiblePermissionsSelected = this.permissionsSelected;

        this.handleSetNumbers(false, true);
        this.handleSetNumbers();
      }

      this.permissionsFirstTimeRequest = false;

      //   this.permissionsSelected = [];
      //   this.visiblePermissionsSelected = [];
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro', 'Erro ao buscar permissões');
    }
  }

  async getGroupPermissionData() {
    try {
      const id = this.route.url.split('/').pop();
      const res = await this.api.get({
        route: `api/fund_document/?draft_document=${id}`,
        token: true,
      });

      this.form.controls.model.setValue(res.draft_document);
      this.form.controls.risk.setValue(res.risk);

      this.permissionsSelected = res.fund.map((item: any) => ({
        label: item.name,
        value: item.fund_id,
      }));

      this.visiblePermissionsSelected = this.permissionsSelected;

      this.permissionsAvaliable = this.permissionsAvaliable.filter((item) => {
        return !this.permissionsSelected.some(
          (selected) => selected.value === item.value
        );
      });

      this.handleSetNumbers(true, true);
      this.handleSetNumbers(true);
      this.handleSetNumbers(false, true);
      this.handleSetNumbers();
    } catch (error) {
      this.toast.show('error', 'Erro', 'Erro ao carregar os dados');
    }
  }

  toggleValue(
    item: SelectItem,
    isUsersCard: boolean = false,
    isAvaliable: boolean = false
  ) {
    if (isUsersCard) {
      if (isAvaliable) {
        if (this.isOptionsChecked(item, true, true)) {
          this.usersAvaliablePicked = this.usersAvaliablePicked.filter(
            (permission) => permission.value !== item.value
          );
        } else {
          this.usersAvaliablePicked.push(item);
        }

        this.handleSetNumbers(true, true);
      } else {
        if (this.isOptionsChecked(item, true)) {
          this.usersSelectedPicked = this.usersSelectedPicked.filter(
            (permission) => permission.value !== item.value
          );
        } else {
          this.usersSelectedPicked.push(item);
        }

        this.handleSetNumbers(true);
      }
    } else {
      if (isAvaliable) {
        if (this.isOptionsChecked(item, false, true)) {
          this.permissionsAvaliablePicked =
            this.permissionsAvaliablePicked.filter(
              (permission) => permission.value !== item.value
            );
        } else {
          this.permissionsAvaliablePicked.push(item);
        }

        this.handleSetNumbers(false, true);
      } else {
        if (this.isOptionsChecked(item)) {
          this.permissionsSelectedPicked =
            this.permissionsSelectedPicked.filter(
              (permission) => permission.value !== item.value
            );
        } else {
          this.permissionsSelectedPicked.push(item);
        }

        this.handleSetNumbers();
      }
    }
  }

  isOptionsChecked(
    item: SelectItem,
    isUsersCard: boolean = false,
    isAvaliable: boolean = false
  ) {
    if (isUsersCard) {
      if (isAvaliable) {
        return this.usersAvaliablePicked.some(
          (permission) => permission.value === item.value
        );
      } else {
        return this.usersSelectedPicked.some(
          (permission) => permission.value === item.value
        );
      }
    } else {
      if (isAvaliable) {
        return this.permissionsAvaliablePicked.some(
          (permission) => permission.value === item.value
        );
      } else {
        return this.permissionsSelectedPicked.some(
          (permission) => permission.value === item.value
        );
      }
    }
  }

  getDisabled(isUsersCard: boolean = false, isAvaliable: boolean = false) {
    if (isUsersCard) {
      return isAvaliable
        ? this.usersAvaliablePicked.length === 0
        : this.usersSelectedPicked.length === 0;
    } else {
      return isAvaliable
        ? this.permissionsAvaliablePicked.length === 0
        : this.permissionsSelectedPicked.length === 0;
    }
  }

  changeSide(isUsersCard: boolean = false, isAvaliable: boolean = false) {
    if (isUsersCard) {
      if (isAvaliable) {
        this.usersAvaliablePicked.forEach((permission) => {
          this.usersSelected.push(permission);
          this.visibleUsersSelected.push(permission);

          this.usersAvaliable = this.usersAvaliable.filter(
            (item) => item.value !== permission.value
          );
        });

        // remove repeated values comparing value

        this.usersSelected = this.usersSelected.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.value === item.value)
        );

        this.visibleUsersSelected = this.visibleUsersSelected.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.value === item.value)
        );

        //  ----

        const searchFormValue = this.searchForm.controls.selectedUsers.value;

        if (searchFormValue)
          this.searchForm.controls.selectedUsers.setValue(searchFormValue);

        this.usersAvaliablePicked = [];
      } else {
        this.usersSelectedPicked.forEach((permission) => {
          //   this.usersAvaliable.push(permission);

          this.usersSelected = this.usersSelected.filter(
            (item) => item.value !== permission.value
          );

          this.visibleUsersSelected = this.visibleUsersSelected.filter(
            (item) => item.value !== permission.value
          );
        });

        this.usersSelectedPicked = [];
        const searchFormValue = this.searchForm.controls.avaliableUsers.value;
        this.searchForm.controls.avaliableUsers.setValue(searchFormValue);
      }

      this.handleSetNumbers(true, true);
      this.handleSetNumbers(true);
    } else {
      if (isAvaliable) {
        this.permissionsAvaliablePicked.forEach((permission) => {
          this.permissionsSelected.push(permission);
          this.visiblePermissionsSelected.push(permission);

          this.permissionsAvaliable = this.permissionsAvaliable.filter(
            (item) => item.value !== permission.value
          );
        });

        this.permissionsSelected = this.permissionsSelected.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.value === item.value)
        );

        this.visiblePermissionsSelected =
          this.visiblePermissionsSelected.filter(
            (item, index, self) =>
              index === self.findIndex((t) => t.value === item.value)
          );

        const searchFormValue =
          this.searchForm.controls.selectedPermissions.value;

        if (searchFormValue)
          this.searchForm.controls.selectedPermissions.setValue(
            searchFormValue
          );

        this.permissionsAvaliablePicked = [];
      } else {
        this.permissionsSelectedPicked.forEach((permission) => {
          this.permissionsSelected = this.permissionsSelected.filter(
            (item) => item.value !== permission.value
          );

          this.visiblePermissionsSelected =
            this.visiblePermissionsSelected.filter(
              (item) => item.value !== permission.value
            );
        });

        this.permissionsSelectedPicked = [];
        const searchFormValue =
          this.searchForm.controls.avaliablePermissions.value;
        this.searchForm.controls.avaliablePermissions.setValue(searchFormValue);
      }

      this.handleSetNumbers(false, true);
      this.handleSetNumbers();
    }
  }

  getSubmitDisabled() {
    return (
      this.form.invalid ||
      this.sendingRequest ||
      this.permissionsSelected.length === 0
    );
  }

  handleSetNumbers(isUsersCard: boolean = false, isAvaliable: boolean = false) {
    if (isUsersCard) {
      if (isAvaliable) {
        this.totalUsersAvaliableOptions = this.usersAvaliable.length;
        this.usersAvaliableCheckedNumber = this.usersAvaliablePicked.length;
      } else {
        this.totalUsersSelectedOptions = this.visibleUsersSelected.length;
        this.usersSelectedCheckedNumber = this.usersSelectedPicked.length;
      }
    } else {
      if (isAvaliable) {
        this.totalPermissionsAvaliableOptions =
          this.permissionsAvaliable.length;
        this.permissionsAvaliableCheckedNumber =
          this.permissionsAvaliablePicked.length;
      } else {
        this.totalPermissionsSelectedOptions =
          this.visiblePermissionsSelected.length;
        this.permissionsSelectedCheckedNumber =
          this.permissionsAvaliablePicked.length;
      }
    }
  }

  async submit() {
    this.sendingRequest = true;
    try {
      const payload = {
        fund: this.permissionsSelected.map((item) => item.value),
        draft_document: this.form.value.model,
        risk: this.form.value.risk,
      };
      this.isEditing
        ? await this.api.put({
            route: `api/fund_document/batch_update/?draft_document=${this.route.url
              .split('/')
              .pop()}/`,
            body: payload,
            token: true,
          })
        : await this.api.post({
            route: 'api/fund_document/',
            body: payload,
            token: true,
          });

      this.toast.show(
        'info',
        'Sucesso',
        this.isEditing
          ? 'Vínculo de minuta atualizado com sucesso'
          : 'Minuta vinculada com sucesso'
      );
      this.route.navigateByUrl(draftsTabUrl('bonds'));
    } catch (error) {
      this.toast.show(
        'error',
        'Erro',
        this.isEditing
          ? 'Erro ao atualizar o vínculo da minuta'
          : 'Erro ao vincular a minuta'
      );
    }

    this.sendingRequest = false;
  }

  handleCancel() {
    this.route.navigateByUrl('app/permissions/groups');
  }

  handleCheckAll(isAvaliable: boolean = false, isUsersCard: boolean = false) {
    if (isUsersCard) {
      if (isAvaliable) {
        const valuesMissingInPicked = this.usersAvaliable.filter(
          (item) =>
            !this.usersAvaliablePicked.some(
              (picked) => picked.value === item.value
            )
        );

        if (valuesMissingInPicked.length === 0) {
          this.usersAvaliablePicked = [];
          this.handleSetNumbers(true, true);
          return;
        }

        valuesMissingInPicked.forEach((item) => {
          this.usersAvaliablePicked.push(item);
        });
        this.handleSetNumbers(true, true);
      } else {
        const valuesMissingInPicked = this.usersSelected.filter(
          (item) =>
            !this.usersSelectedPicked.some(
              (picked) => picked.value === item.value
            )
        );

        if (valuesMissingInPicked.length === 0) {
          this.usersSelectedPicked = [];
          this.handleSetNumbers(true, false);

          return;
        }

        valuesMissingInPicked.forEach((item) => {
          this.usersSelectedPicked.push(item);
        });
        this.handleSetNumbers(true, false);
      }
    } else {
      if (isAvaliable) {
        const valuesMissingInPicked = this.permissionsAvaliable.filter(
          (item) =>
            !this.permissionsAvaliablePicked.some(
              (picked) => picked.value === item.value
            )
        );

        if (valuesMissingInPicked.length === 0) {
          this.permissionsAvaliablePicked = [];
          this.handleSetNumbers(false, true);
          return;
        }

        valuesMissingInPicked.forEach((item) => {
          this.permissionsAvaliablePicked.push(item);
        });
        this.handleSetNumbers(false, true);
      } else {
        const valuesMissingInPicked = this.visiblePermissionsSelected.filter(
          (item) =>
            !this.permissionsSelectedPicked.some(
              (picked) => picked.value === item.value
            )
        );

        if (valuesMissingInPicked.length === 0) {
          this.permissionsSelectedPicked = [];
          this.handleSetNumbers();
          return;
        }

        valuesMissingInPicked.forEach((item) => {
          this.permissionsSelectedPicked.push(item);
        });
        this.handleSetNumbers();
      }
    }
  }

  verifyCheckAll(isAvaliable: boolean = false, isUsersCard: boolean = false) {
    if (isUsersCard) {
      if (isAvaliable) {
        return this.usersAvaliablePicked.length === this.usersAvaliable.length;
      }

      return (
        this.usersSelectedPicked.length === this.visibleUsersSelected.length
      );
    } else {
      if (isAvaliable) {
        return (
          this.permissionsAvaliablePicked.length ===
          this.permissionsAvaliable.length
        );
      }
      return (
        this.permissionsSelectedPicked.length ===
        this.visiblePermissionsSelected.length
      );
    }
  }

  checkUserType(type: string) {
    return type === 'master' ? this.isMaster : this.isSimple;
  }

  toggleType(type: string) {
    this.isMaster = type === 'master';
    this.isSimple = type === 'simple';
  }

  setBreadcrumb(): void {
    const canViewDrafts =
      this.authService.verifyPermission('de_can_view_drafts');
    const canViewBonds = this.authService.verifyPermission('de_can_view_bonds');
    const isNew = this.route.url.includes('new');
    const breadcrumbs: BreadcrumbItem[] = [
      {
        label: 'Minutas',
        url: DRAFTS_PAGE_URL,
        clickable: canViewDrafts,
      },
      {
        label: 'Vínculos',
        url: draftsTabUrl('bonds'),
        clickable: canViewBonds,
      },
      {
        label: isNew ? 'Novo vínculo' : 'Atualizar vinculo',
        url: this.route.url,
        clickable: false, // Página atual, não precisa ser clicável
      },
    ];
    this.breadcrumbService.setBreadcrumbs(breadcrumbs);
  }
}
